export default [
  {
    text: 'Conta corrente',
    value: 'ContaCorrente',
  },
  {
    text: 'Conta poupança',
    value: 'ContaPoupanca',
  },
];
